import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AuroraHeader, AuroraFooter } from "../components/aurora/Header";
import { api } from "../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.adminLogin(password);
      toast.success("Welcome back, Ivy");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid password");
      setSubmitting(false);
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{
        backgroundImage:
          "linear-gradient(rgba(250, 245, 238, 0.92), rgba(250, 245, 238, 0.98)), url('https://images.unsplash.com/photo-1641355262431-021a396d4fe5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMHRvcG9ncmFwaGljJTIwbWFwJTIwZGFya3xlbnwwfHx8fDE3ODA1NzEyOTV8MA&ixlib=rb-4.1.0&q=85')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <AuroraHeader compact />
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md border border-[#A88059] p-10 bg-[#FAF5EE] shadow-lg">
          <div className="label-eyebrow text-[#6B4D2B] mb-3">Aurora Console</div>
          <h2 className="font-heading text-3xl text-[#190F08] mb-2">Admin Sign-In</h2>
          <p className="font-body text-[#6B5E4A] text-sm mb-8">
            Restricted access. Authorised personnel only.
          </p>

          <hr className="gold-rule mb-8" />

          <form onSubmit={submit}>
            <div className="label-eyebrow mb-2">Password</div>
            <input
              type="password"
              className="aurora-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus
              data-testid="input-admin-password"
            />
            <button
              type="submit"
              className="btn-primary w-full mt-8"
              disabled={submitting}
              data-testid="btn-admin-login"
            >
              {submitting ? "Signing in..." : "Enter Console"}
            </button>
          </form>
        </div>
      </main>
      <AuroraFooter />
    </div>
  );
}
